import { connect } from "react-redux";
import Footer from "../components/Footer/Footer";
import { getAPIBuildNumber } from "../actions/App";

import { tail } from "lodash";

const mapStateToProps = (state) => {
  const {
    apiBuildNumber,
    client_info,
    roleId,
    selected_client,
    optimizeUserDetail,
    loginUserDetail,
  } = state.app;
  const { categories } = state.segmentCreation;
  const demographic = categories ? tail(categories) : undefined;

  return {
    location: {
      path: state.routing.location.pathname,
      queryStep: state.routing.location.match
        ? state.routing.location.match.params.step
        : "",
      query: state.routing.location.match
        ? state.routing.location.match.params
        : null,
    },
    apiBuildNumber: apiBuildNumber,
    client_info,
    roleId,
    demoAttributes: demographic,
    selected_client,
    loginUserDetail,
    optimizeUserDetail,
    hideFooter:
      /^\/login/g.test(state.routing.location.pathname) ||
      /^\/resetpassword/g.test(state.routing.location.pathname) ||
      /^\/changepassword/g.test(state.routing.location.pathname),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAPIBuildNumber: () => {
      dispatch(getAPIBuildNumber());
    },
  };
};

const FooterContainer = connect(mapStateToProps, mapDispatchToProps)(Footer);

export default FooterContainer;



// WEBPACK FOOTER //
// ./src/containers/Footer.js